import React from 'react';
import { Stack, Box, useTheme, alpha } from '@mui/material';

interface MasteryDotsProps {
  mastery: number;
  maxMastery?: number;
  highlighted?: boolean;
}

export const MasteryDots: React.FC<MasteryDotsProps> = ({
  mastery,
  maxMastery = 5,
  highlighted = false,
}) => {
  const theme = useTheme();

  return (
    <Stack direction="row" justifyContent="center" spacing={1} sx={{ mt: 3, mb: 4 }}>
      {Array.from({ length: maxMastery }).map((_, index) => {
        const isComplete = index < mastery;
        return (
          <Box
            key={index}
            sx={{
              width: 20,
              height: 20,
              borderRadius: '50%',
              backgroundColor: isComplete
                ? 'warning.main'
                : highlighted
                ? alpha(theme.palette.common.white, 0.3)
                : 'divider',
              transition: 'all 0.3s ease',
              transform: isComplete ? 'scale(1.1)' : 'none',
            }}
            title={isComplete ? `Completed ${index + 1}/${maxMastery}` : `Remaining ${maxMastery - index}`}
          />
        );
      })}
    </Stack>
  );
};
